module.exports = __webpack_public_path__ + "src/_content/imgs/bmw.svg?1f4346f91232f704e3006ff72e07ac52";